import { LocationEntity } from "@src/core/entities";
import initialState from "./state";
import { ICreateOrderInitialState } from "./types";
import { CaseReducer, PayloadAction } from "@reduxjs/toolkit";

const resetState: CaseReducer<ICreateOrderInitialState, PayloadAction> = () => {
  return initialState;
};

const setTakeOffLocation: CaseReducer<ICreateOrderInitialState, PayloadAction<LocationEntity>> = (state, action) => {
  state.takeOffLocation = action.payload;
};

const setDestinationLocation: CaseReducer<ICreateOrderInitialState, PayloadAction<LocationEntity>> = (state, action) => {
  state.destinationLocation = action.payload;
};

const setReadOnlyTakeOff: CaseReducer<ICreateOrderInitialState, PayloadAction<boolean>> = (state, action) => {
  state.readOnlyTakeOff = action.payload;
};

export default { resetState, setReadOnlyTakeOff, setTakeOffLocation, setDestinationLocation };